import { render, staticRenderFns } from "./orderOption.vue?vue&type=template&id=2bf13c38"
import script from "./orderOption.vue?vue&type=script&lang=js"
export * from "./orderOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports